module.exports = __webpack_public_path__ + "static/media/boonedam.bf97a397.png";